export const testCases = {
  humanWritten: [
    {
      category: "Professional Writing",
      samples: [
        {
          text: "The impact of climate change on global ecosystems is both profound and complex. Recent studies have shown varying effects across different regions, with some areas experiencing more severe consequences than others. While certain species adapt to these changes, others face significant challenges in survival.",
          expectedAIScore: "low",
          description: "Natural professional writing with complex structure"
        }
      ]
    },
    {
      category: "Casual Writing",
      samples: [
        {
          text: "Hey! I was thinking about what you said yesterday. It really made me stop and think, you know? Sometimes we get so caught up in our daily routines that we forget to look at the bigger picture. What do you think?",
          expectedAIScore: "low",
          description: "Natural conversational writing with informal tone"
        }
      ]
    }
  ],
  aiGenerated: [
    {
      category: "ChatGPT-like",
      samples: [
        {
          text: "Here is a comprehensive analysis of the situation: First, we must consider the primary factors involved. Second, let's examine the potential implications. Finally, we can draw conclusions based on the available data. This structured approach will help us understand the matter more clearly.",
          expectedAIScore: "high",
          description: "Typical AI-generated structured response"
        }
      ]
    }
  ],
  mixed: [
    {
      category: "Human-Edited AI Content",
      samples: [
        {
          text: "I've been researching quantum computing lately. [AI section: Quantum computing utilizes quantum mechanical phenomena such as superposition and entanglement to perform computations.] It's fascinating how these concepts could revolutionize our approach to complex problems.",
          expectedAIScore: "medium",
          description: "Human writing with AI-generated technical explanation"
        }
      ]
    }
  ],
  edgeCases: [
    {
      category: "Very Short Text",
      samples: [
        {
          text: "Hello, how are you today?",
          expectedAIScore: "inconclusive",
          description: "Too short for reliable analysis"
        }
      ]
    },
    {
      category: "Technical Documentation",
      samples: [
        {
          text: "The function accepts two parameters: x (number) and y (string). Returns void. Throws InvalidArgumentException if x < 0.",
          expectedAIScore: "ambiguous",
          description: "Technical writing that might be mistaken for AI"
        }
      ]
    }
  ]
};

export const getRandomSample = (category: keyof typeof testCases): typeof testCases[keyof typeof testCases][0]['samples'][0] => {
  const categoryData = testCases[category];
  const randomCategory = categoryData[Math.floor(Math.random() * categoryData.length)];
  return randomCategory.samples[Math.floor(Math.random() * randomCategory.samples.length)];
};

export const getAllSamples = () => {
  const allSamples: Array<{
    category: string;
    text: string;
    expectedAIScore: string;
    description: string;
  }> = [];

  Object.entries(testCases).forEach(([mainCategory, categories]) => {
    categories.forEach(category => {
      category.samples.forEach(sample => {
        allSamples.push({
          category: `${mainCategory} - ${category.category}`,
          ...sample
        });
      });
    });
  });

  return allSamples;
}; 